import { render } from "./ServiceModel.vue?vue&type=template&id=08da4837&scoped=true"
import script from "./ServiceModel.vue?vue&type=script&lang=js"
export * from "./ServiceModel.vue?vue&type=script&lang=js"

import "./ServiceModel.vue?vue&type=style&index=0&id=08da4837&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08da4837"]])

export default __exports__